import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

import { ModalMetadataComponent } from './modal-metadata.component';

@NgModule({
  imports: [CommonModule, IonicModule],
  declarations: [ModalMetadataComponent],
  providers: [],
})
export class ModalMetadataModule {}
